/**
 * Created by Carsten Hibbeler on 13.05.2016.
 * https://github.com/KyleAMathews/deepmerge
 */
export default function deepMerge(target, src) {
    let array = Array.isArray(src);
    let dst = array && [] || {};
    if (array) {
        target = target || [];
        dst = dst.concat(target);
        src.forEach(function (e, i) {
            if (typeof dst[ i ] === 'undefined') {
                dst[ i ] = e;
            } else if (typeof e === 'object') {
                dst[ i ] = deepMerge(target[ i ], e);
            } else {
                if (target.indexOf(e) === -1) {
                    dst.push(e);
                }
            }
        });
    } else {
        if (target && typeof target === 'object') {
            Object.keys(target).forEach(function (key) {
                dst[ key ] = target[ key ];
            })
        }
        Object.keys(src).forEach(function (key) {
            if (typeof src[ key ] !== 'object' || !src[ key ]) {
                dst[ key ] = src[ key ];
            }
            else {
                if (!target[ key ]) {
                    dst[ key ] = src[ key ];
                } else {
                    dst[ key ] = deepMerge(target[ key ], src[ key ]);
                }
            }
        });
    }

    return dst;
}



// WEBPACK FOOTER //
// ./js/utils/deepMerge.js